import React, {useState} from 'react';
import {useColorThemeType, useFontTheme} from '../../../appStyles/hooks/theme';

import {Box} from '../../../components/core/view';
import If from '@buncha/components/conditional/If';
import {Modules} from '@buncha/utils/types';
import {PSmallText} from '../../../components/core/text';
import {Platform} from 'react-native';
import {ShopperScreens} from '@buncha/home/navigation/types';
import {Touchable} from '@buncha/components/core/touchable';
import font from '../../../appStyles/style/font';
import {notesBoxStyles} from './styles';
import {useGetLocale} from '@buncha/localization/hooks';

interface NotesProps {
  orderItemNotes: string;
}

const Notes = (props: NotesProps) => {
  const theme = useColorThemeType('main');
  const muliFont = useFontTheme('muli');
  const {body} =
    useGetLocale(Modules.batchDetails, ShopperScreens.BatchDetailsPage) ?? {};
  const [initialLinesToShow, setInitialLinesToShow] = useState(
    Platform.OS === 'android' ? 1 : 0,
  );
  const [numLines, setNumLines] = useState(initialLinesToShow);
  const [showFullText, setShowFullText] = useState(false);
  const notesText = `Notes: ${props.orderItemNotes}`;

  const handleTextLayout = (event: {nativeEvent: {lines: any}}) => {
    const {lines} = event.nativeEvent;
    setInitialLinesToShow(1);
    if (initialLinesToShow < lines.length) setNumLines(lines.length);
  };

  const handleSeeMoreClick = () => {
    setShowFullText(!showFullText);
  };

  const handleSeeLessClick = () => {
    setShowFullText(false);
  };

  return (
    <Box style={[notesBoxStyles.notesBox]}>
      <PSmallText
        onTextLayout={handleTextLayout}
        style={[
          notesBoxStyles.notesText,
          {
            fontFamily: muliFont[700].normal,
            color: theme?.text.gray[100],
          },
        ]}
        numberOfLines={showFullText ? numLines : initialLinesToShow}>
        {notesText}
      </PSmallText>
      <If condition={!showFullText && numLines > initialLinesToShow}>
        <Touchable onPress={handleSeeMoreClick}>
          <PSmallText
            style={[
              {
                color: theme?.text.blue[100],
                fontFamily: font.fonts.muliSemiBold,
              },
              notesBoxStyles.seeMore,
            ]}>
            {body?.notes?.[0]}
          </PSmallText>
        </Touchable>
      </If>
      <If condition={showFullText}>
        <Touchable onPress={handleSeeLessClick}>
          <PSmallText
            style={[
              {
                color: theme?.text.blue[100],
                fontFamily: font.fonts.muliSemiBold,
              },
              notesBoxStyles.seeLess,
            ]}>
            {body?.notes?.[1]}
          </PSmallText>
        </Touchable>
      </If>
    </Box>
  );
};

export default React.memo(Notes);
